<template>
  <div style="margin: 0 48px 8px;">
    <el-form ref="formRef" :model="commodityForm" label-width="auto" label-position="right">
      <el-form-item label="供应商：">
        <el-select v-model="supplierId" placeholder="请选择供应商" style="width: 100%" filterable>
          <el-option v-for="item in supplierIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <p v-if="idx == -1" style="line-height: 1;margin-top: 8px;">没有找到供应商？请<span class="line-btn" @click="goSupplier">点击新增供应商</span></p>
      </el-form-item>
      <el-form-item label="品牌：">
        <el-select v-model="brandId" placeholder="请选择品牌" style="width: 100%" filterable>
          <el-option v-for="item in brandIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <p v-if="idx == -1" style="line-height: 1;margin-top: 8px;">没有找到品牌？请<span class="line-btn" @click="goBrand">点击新增供品牌</span></p>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input v-model="commodityForm.name" placeholder="请输入商品名称"/>
      </el-form-item>
      <el-form-item label="商品分类：">
        <div style="display: flex; width: 100%">
          <el-select v-model="typeId" placeholder="请选择分类" @change="typeChange" style="width: 100%" filterable>
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="subTypeId" placeholder="请选择子分类" v-if="subTypeList.length > 0" style="width: 100%; margin-left: 8px;" filterable>
            <el-option v-for="item in subTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="商品规格：">
        <el-input v-model="commodityForm.specification" placeholder="请输入规格"/>
      </el-form-item>
      <el-form-item label="计量单位：">
        <el-select v-model="measureUnit" placeholder="请选择计量单位" style="width: 100%">
          <el-option v-for="item in measureUnitArray" :key="item.type" :label="item.name" :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="进货单价：">
        <el-input v-model="commodityForm.price" placeholder="请输入进货单价" />
      </el-form-item>
      <el-form-item label="建议零售价：">
        <el-input v-model="commodityForm.retailPrice" placeholder="请输入建议零售价" />
      </el-form-item>
      <el-form-item label="门店零售价：">
        <div style="display: flex; align-items: center; width: 100%">
          <el-input v-model="commodityForm.shopRetailPrice" placeholder="请输入门店零售价" style="width: 100%; flex: 1"/>
          <el-checkbox v-model="shopRetailEdit" :true-label="1" :false-label="0" style="margin-left: 16px;"><span style="white-space: nowrap">允许门店修改价格</span></el-checkbox>
        </div>

      </el-form-item>
      <el-form-item label="是否回访：">
        <el-radio-group v-model="visitType" @change="visitTypeChange">
          <el-radio :label="1">无需回访</el-radio>
          <el-radio :label="2">立即回访</el-radio>
          <el-radio :label="3">回访天数</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="回访天数：" v-if="visitType == 3">
        <el-input v-model="commodityForm.visitDay" placeholder="请输入回访天数" />
      </el-form-item>
      <el-form-item label="图片：" v-if="idx > -1">
        <div>
          <el-space>
            <div class="img-box" v-for="(item, index) in imgArray.slice(0, 4)" :key="item.id">
              <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              <div v-if="item.isCover == 1" class="cover-tag">封面</div>
            </div>
            <div class="add" v-if="imgArray.length > 0" @click="userImgList()">
              <span>全部图片</span>
            </div>
          </el-space>
          <div>
            <el-button @click="fileUpdate">+ 上传图片</el-button>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png,.heic"  @change="fileChanged" ref="file" multiple="multiple" style="display:none;">
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateCommodity, listMeasureUnit, listAllBrand, listAllSupplier, listAllCommodityType, listAllCommodityImg} from "@/api/url";
import {greaterIntReg, phoneReg} from "@/assets/shared/reg-constant";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import Dialog from "@/assets/js/dialog";
import UserImgUpload from "@/components/imgList/UserImgUpload";
import { moneyReg, positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      commodityForm: this.value.commodityForm,
      idx: this.value.ids,

      supplierIdArray: [],
      supplierId: this.value.commodityForm.supplierId?this.value.commodityForm.supplierId:'',

      brandIdArray: [],
      brandId: this.value.commodityForm.brandId?this.value.commodityForm.brandId:'',

      measureUnitArray: [],
      measureUnit: this.value.commodityForm.measureUnit?this.value.commodityForm.measureUnit:'',
      shopRetailEdit: 1,

      typeList: [],
      typeId: '',
      subTypeList: [],
      subTypeId: '',

      imgArray: this.value.commodityForm.commodityImgList?this.value.commodityForm.commodityImgList:[],

      visitType: this.value.commodityForm.visitDay == -1?1:this.value.commodityForm.visitDay == 0?2:this.value.commodityForm.visitDay > 0?3:1,

    }
  },
  methods: {

    visitTypeChange(val) {
      if(val == 3){
        this.projectForm.visitDay = ''
      }
    },

    goSupplier() {
      this.$emit("goNext", 1);
    },

    goBrand() {
      this.$emit("goNext", 2);
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      // console.log(this.idx)
      if(!this.supplierId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择供应商',
          type: 'warning'
        });
        return false
      }
      if(!this.brandId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择品牌',
          type: 'warning'
        });
        return false
      }
      if(!this.commodityForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入商品名称',
          type: 'warning'
        });
        return false
      }
      if(!this.typeId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择商品分类',
          type: 'warning'
        });
        return false
      }
      if(!this.measureUnit) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择计量单位',
          type: 'warning'
        });
        return false
      }
      if(!this.commodityForm.price && this.commodityForm.price !=0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入进货单价',
          type: 'warning'
        });
        return false
      }else if(!moneyReg.test(this.commodityForm.price)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的进货单价',
          type: 'warning'
        });
        return false
      }
      if(this.commodityForm.retailPrice && !moneyReg.test(this.commodityForm.retailPrice)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的建议零售价',
          type: 'warning'
        });
        return false
      }
      if(!moneyReg.test(this.commodityForm.shopRetailPrice)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的门店零售价',
          type: 'warning'
        });
        return false
      }
      if(this.visitType == 3 && !greaterIntReg.test(this.commodityForm.visitDay)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入正确的回访天数',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.commodityForm.id:0;
      param['name'] = this.commodityForm.name;
      param['supplierId'] = this.supplierId;
      param['brandId'] = this.brandId;
      param['commodityTypeId'] = this.subTypeId?this.subTypeId:this.typeId;
      param['specification'] = this.commodityForm.specification;
      param['measureUnit'] = this.measureUnit;
      param['price'] = this.commodityForm.price;
      param['retailPrice'] = this.commodityForm.retailPrice;
      param['shopRetailPrice'] = this.commodityForm.shopRetailPrice;
      param['shopRetailEdit'] = this.shopRetailEdit;
      param['visitDay'] = this.visitType == 1?-1:this.visitType == 2?0:this.commodityForm.visitDay
      postFormData(addOrUpdateCommodity, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    getSupplierList() {
      getFormData(listAllSupplier).then(data=> {
        this.supplierIdArray = this.supplierIdArray.concat(data.data)
      })
    },

    getBrandList() {
      getFormData(listAllBrand).then(data=> {
        this.brandIdArray = this.brandIdArray.concat(data.data)
      })
    },

    getMeasureUnitList() {
      getFormData(listMeasureUnit).then(data=> {
        this.measureUnitArray = this.measureUnitArray.concat(data.data)
      })
    },

    getCommodityTypeList() {
      getFormData(listAllCommodityType).then(data=> {
        this.typeList = this.typeList.concat(data.data)
        if(this.idx > -1 || this.idx == -2) {
          if(this.commodityForm.commodityTypePreId) {
            this.typeId = this.commodityForm.commodityTypePreId
            this.subTypeId = this.commodityForm.commodityTypeId
          }else {
            this.typeId = this.commodityForm.commodityTypeId
          }
          for(let i=0; i<this.typeList.length; i++) {
            if(this.typeList[i].id == this.typeId) {
              this.subTypeList = this.typeList[i].subTypeList
            }
          }
        }else {
          this.subTypeList = this.typeList[0].subTypeList
        }
      })
    },

    typeChange() {
      this.subTypeId = ''
      for(let i=0; i<this.typeList.length; i++) {
        if(this.typeList[i].id == this.typeId) {
          this.subTypeList = this.typeList[i].subTypeList
        }
      }
    },

    userImgList() {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: this.imgArray,
          id: this.commodityForm.id,
          width: 908,
          from: 2,
        },
        confirm: (result) => {
          this.getCommodityImgList()
        }
      })
    },

    //更改或添加
    fileUpdate() {
      this.$refs.file.setAttribute('type', 'file')
      this.$refs.file.click();
    },

    //选取图片
    fileChanged(e) {
      if(e.target.files[0]) {
        let imgArr = []
        for(let item of e.target.files) {
          let windowURL = window.URL || window.webkitURL;
          let src = windowURL.createObjectURL(item);
          let obj = {'img': src, 'smallImg': src, 'files': item};
          // this.imgArray.push(obj);
          imgArr.push(obj)
        }
        this.$refs.file.setAttribute('type', 'text')
        Dialog.open({
          title: '上传图片',
          component: UserImgUpload,
          data: {
            imgArray: imgArr,
            id: this.commodityForm.id,
            width: '800px',
            from: 2,
          },
          confirm: (result) => {

            this.getCommodityImgList()
          }
        })
      }
    },

    getCommodityImgList() {
      getFormData(listAllCommodityImg, {id: this.commodityForm.id}).then(data=> {
        this.imgArray = data.data
      })
    },


  },
  mounted() {
    this.getSupplierList()
    this.getBrandList()
    this.getMeasureUnitList()
    this.getCommodityTypeList()
    if(this.idx > -1) {
      this.shopRetailEdit = this.commodityForm.shopRetailEdit
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ccc;
  font-size: 12px;
  cursor: pointer;
  /*float: left;*/
}
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.cover-tag {
  position: absolute;
  height: 20px;
  width: 32px;
  top: 0;
  left: 0;
  /*padding: 0 8px;*/
  text-align: center;
  line-height: 20px;
  font-size: 10px;
  color: #ffffff;
  background-color: #409eff;
  border-bottom-right-radius: 4px;
}

.line-btn {
  color: #409eff;
  cursor: pointer;
}

.line-btn:hover {
  text-decoration: underline;
}

</style>
